export const PageTitle: React.FC = ({ children }) => (
  <div className="column is-full px-5 py-0 mt-5">
    <h1 className="title is-1 has-text-weight-bold">
      {children}
    </h1>
  </div>
)